import React from 'react';
import { Container, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    backgroundColor: theme.palette.background.default,
    marginTop: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  footer: {
    padding: theme.spacing(5, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 0),
    },
  },
}));

interface IProps {
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
}

const Footer: React.FC<React.PropsWithChildren<IProps>> = ({ left, center, right }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.wrapper}>
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="space-between" className={classes.footer}>
          <Grid item>{left}</Grid>
          <Grid item>{center}</Grid>
          <Grid item>{right}</Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Footer;
